import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=85def642&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=85def642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85def642",
  null
  
)

export default component.exports